var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.004,
    height: 67.131,
    viewBox: "0 0 82.004 67.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-checkin",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4223",
    "data-name": "Path 4223",
    d: "M54.942,43.877V36.751A14.251,14.251,0,0,0,40.691,22.5H15.751A14.251,14.251,0,0,0,1.5,36.751v7.126",
    transform: "translate(0 24.754)",
    fill: "none",
    stroke: "#410a8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4224",
    "data-name": "Path 4224",
    d: "M35.253,18.751A14.251,14.251,0,1,1,21,4.5,14.251,14.251,0,0,1,35.253,18.751Z",
    transform: "translate(7.22)",
    fill: "none",
    stroke: "#410a8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4225",
    "data-name": "Path 4225",
    d: "M25.5,20.626l7.126,7.126L46.877,13.5",
    transform: "translate(33.005 12.377)",
    fill: "none",
    stroke: "#410a8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheckin);
export default __webpack_public_path__ + "static/media/user-checkin.d56d5394b3959c472cf92b0cccd67c63.svg";
export { ForwardRef as ReactComponent };